export const CLASSY_FONT_FAMILY_DESIGN_TOKENS = {
  // * Default Font stack
  '--classy-font__font-family--base': 'system-ui,-apple-system,BlinkMacSystemFont,"San Francisco","Segoe UI",Roboto,"Helvetica Neue",sans-serif',
  // * Supported Web Safe Fonts
  '--classy-font__font-family--arial': 'Arial',
  '--classy-font__font-family--georgia': 'Georgia',
  '--classy-font__font-family--impact': 'Impact',
  '--classy-font__font-family--tahoma': 'Tahoma',
  '--classy-font__font-family--times-new-roman': 'Times New Roman',
  '--classy-font__font-family--verdana': 'Verdana',
  // * Supported Custom Fonts
  // Avenir was added for MSF / Doctors Without Borders (CL-46099) */
  '--classy-font__font-family--avenir': 'Avenir',
  // * Supported Google Fonts
  '--classy-font__font-family--domine': 'Domine',
  '--classy-font__font-family--inter': 'Inter',
  '--classy-font__font-family--karla': 'Karla',
  '--classy-font__font-family--lato': 'Lato',
  '--classy-font__font-family--libre-caslon-display': 'Libre Caslon Display',
  '--classy-font__font-family--libre-caslon-text': 'Libre Caslon Text',
  '--classy-font__font-family--merriweather': 'Merriweather',
  '--classy-font__font-family--montserrat': 'Montserrat',
  '--classy-font__font-family--noto-sans': 'Noto Sans',
  '--classy-font__font-family--nunito': 'Nunito',
  '--classy-font__font-family--nunito-sans': 'Nunito Sans',
  '--classy-font__font-family--open-sans': 'Open Sans',
  '--classy-font__font-family--oswald': 'Oswald',
  '--classy-font__font-family--outfit': 'Outfit',
  '--classy-font__font-family--playfair-display': 'Playfair Display',
  '--classy-font__font-family--poppins': 'Poppins',
  '--classy-font__font-family--pt-sans': 'PT Sans',
  '--classy-font__font-family--raleway': 'Raleway',
  '--classy-font__font-family--roboto': 'Roboto',
  '--classy-font__font-family--roboto-condensed': 'Roboto Condensed',
  '--classy-font__font-family--slabo-13px': '"Slabo 13px"',
  '--classy-font__font-family--slabo-27px': '"Slabo 27px"',
  '--classy-font__font-family--source-sans-3': '"Source Sans 3"',
  '--classy-font__font-family--source-serif-4': '"Source Serif 4"',
  '--classy-font__font-family--work-sans': 'Work Sans'
};
export const CLASSY_DESIGN_TOKENS = {
  ...CLASSY_FONT_FAMILY_DESIGN_TOKENS,
  // * Typography Styles
  '--classy-font__label--font-size': '12px',
  '--classy-font__label--line-height': '1.5',
  '--classy-font__label--font-weight': '400',
  '--classy-font__paragraph-sm--font-size': '14px',
  '--classy-font__paragraph-sm--line-height': '1.5',
  '--classy-font__paragraph-sm--font-weight': '400',
  '--classy-font__paragraph-sm-bold--font-size': 'var(--classy-font__paragraph-sm--font-size)',
  '--classy-font__paragraph-sm-bold--line-height': 'var(--classy-font__paragraph-sm--line-height)',
  '--classy-font__paragraph-sm-bold--font-weight': '700',
  '--classy-font__paragraph-md--font-size': '16px',
  '--classy-font__paragraph-md--line-height': '1.5',
  '--classy-font__paragraph-md--font-weight': '400',
  '--classy-font__paragraph-md-bold--font-size': 'var(--classy-font__paragraph-md--font-size)',
  '--classy-font__paragraph-md-bold--line-height': 'var(--classy-font__paragraph-md--line-height)',
  '--classy-font__paragraph-md-bold--font-weight': '700',
  '--classy-font__paragraph-lg-bold--font-size': '20px',
  '--classy-font__paragraph-lg-bold--line-height': '1.5',
  '--classy-font__paragraph-lg-bold--font-weight': '700',
  '--classy-font__heading-xs--font-size': '24px',
  '--classy-font__heading-xs--line-height': '1.2',
  '--classy-font__heading-xs--font-weight': '700',
  '--classy-font__heading-sm--font-size': '28px',
  '--classy-font__heading-sm--line-height': '1.2',
  '--classy-font__heading-sm--font-weight': '700',
  // * Border Radius
  '--classy-border__radius-sm': '4px',
  '--classy-border__radius-md': '8px',
  '--classy-border__radius-lg': '12px',
  '--classy-border__radius-xl': '16px',
  '--classy-border__radius-xxl': '20px',
  // * What we do in the Shadows 🧛‍♂️🧛‍♀️🧛
  '--classy-shadow__button': '"0 2px 2px 0 rgb(27 25 24 / 12%)"',
  '--classy-shadow__text': '0 1px 1px 0 rgb(0 0 0 / 24%)',
  '--classy-shadow__alert': '0 4px 8px 0 rgb(28 25 23 / 12%)',
  '--classy-shadow__modal': '0 16px 32px 0 rgb(27 25 24 / 12%)',
  '--classy-shadow__sheet': '0 0 16px 0 rgb(27 25 24 / 24%)',
  '--classy-shadow__active': '0px 2px 2px 0px rgb(0 0 0 / 24%) inset, 1px 1px 1px 0px rgb(0 0 0 / 24%) inset',
  '--classy-shadow__inactive': '0px -2px 4px 0px rgb(0 0 0 / 12%) inset, 1px 2px 4px 0px rgb(255 255 255 / 12) inset',
  '--classy-shadow__card': '0 2px 4px 0 rgb(25 29 34 / 10%)',
  // * Colors
  '--classy-color__neutral--10': 'rgb(26, 25, 25)',
  '--classy-color__neutral--20': 'rgb(49, 47, 45)',
  '--classy-color__neutral--30': 'rgb(80, 76, 73)',
  '--classy-color__neutral--40': 'rgb(106, 101, 98)',
  '--classy-color__neutral--45': 'rgb(120, 114, 110)',
  '--classy-color__neutral--50': 'rgb(133, 127, 122)',
  '--classy-color__neutral--60': 'rgb(157, 152, 149)',
  '--classy-color__neutral--70': 'rgb(181, 178, 176)',
  '--classy-color__neutral--80': 'rgb(206, 204, 202)',
  '--classy-color__neutral--90': 'rgb(230, 229, 229)',
  '--classy-color__neutral--95': 'rgb(243, 242, 242)',
  '--classy-color__neutral--100': 'rgb(255, 255, 255)',
  '--classy-color__border--input': 'var(--classy-color__neutral--50)',
  '--classy-color__border--input-hover': 'var(--classy-color__neutral--60)',
  '--classy-color__border--lightest': 'rgb(235, 234, 234)',
  '--classy-color__border--neutral-subtle': 'rgb(216, 216, 216)',
  '--classy-color__border--placeholder': 'rgb(248, 247, 247)',
  '--classy-color__border--focus': 'rgb(41, 114, 255)',
  '--classy-color__border--card': 'rgb(0 0 0 / 12%)',
  '--classy-color__background': 'rgb(255, 255, 255)',
  '--classy-color__background--accent': 'rgb(245, 245, 245)',
  '--classy-color__background--lightest': 'var(--classy-color__neutral--95)',
  '--classy-color__background--input': 'rgb(248, 247, 247)',
  '--classy-color__background--backdrop': 'rgb(255 255 255 / 80%)',
  '--classy-color__background--backdrop-dark': 'rgb(26 25 25 / 80%)',
  '--classy-color__status--error-base': 'rgb(169, 15, 15)',
  '--classy-color__status--error-lightest': 'rgb(254, 246, 246)',
  '--classy-color__status--success-base': 'rgb(46, 125, 50)',
  // * Form Field
  '--classy-form-input__padding--block': '8px',
  '--classy-form-input__padding--inline': '12px',
  /*
   * * Component-specific
   * ! FIXME align breakpoint names with design system, CL-27142
   */
  '--classy-layout__max-width--tablet': '1280px',
  '--classy-section__padding-inline--mobile': '24px',
  '--classy-section__padding-block--mobile': '24px',
  '--classy-section__padding-inline--tablet': '32px',
  '--classy-section__padding-block--tablet': '48px',
  '--classy-content__width--wide': '768px',
  // Heart tokens (cleanup when we add Heart for realises)
  '--heart-color__text--default': 'rgb(35, 35, 35)',
  '--heart-color__text--supporting': 'rgb(111, 111, 111)'
};